
/**
 * Retrieves the default market.
 * If the `DEFAULT_MARKET` environment variable is defined, it returns its value.
 * Otherwise, it returns the default value 'ww'.
 *
 * @returns The default market.
 */
function getDefaultMarket(): string {
  let defaultMarket = 'ww';
  if (typeof process !== 'undefined' && process.env.DEFAULT_MARKET) {
    defaultMarket = process.env.DEFAULT_MARKET;
  }
  return defaultMarket;
}

export const defaultMarket = getDefaultMarket();
